export const goodsDefaultMeasurments: {
  [key: string]: {
    width: string;
    height: string;
  };
} = {
  doorsFields: {
    width: '0,7',
    height: '2',
  },
  windowsFields: {
    width: '2,04',
    height: '1,35',
  },
};

export const SHOULD_BE_MORE_THEN_ZERO = 'Должна быть > 0';
